import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ReCaptchaV3Service } from "ng-recaptcha-2";
import { Subscription } from "rxjs";
import { LoginDataService } from "src/app/data-repositories/login-data.service";
import { AuthService } from "src/app/repositories/auth.service";
import {BrowserStorageService} from '../../services/browser-storage.service';

@Component({
  standalone: false,
  selector: "app-login-by-phone",
  templateUrl: "./login-by-phone.component.html",
  styleUrls: ["./login-by-phone.component.scss"],
})
export class LoginByPhoneComponent implements OnInit, OnDestroy {
  private recaptchaV3ServiceSubscription: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loginService: LoginDataService,
    private authService: AuthService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private browseStorage: BrowserStorageService,
  ) {}

  ngOnDestroy(): void {
    this.recaptchaV3ServiceSubscription.unsubscribe();
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      const { phone, ...otherParams } = params;

      this.recaptchaV3ServiceSubscription = this.recaptchaV3Service
        .execute("login_by_phone")
        .subscribe(
          (token) => {
            if (phone && phone !== "") {
              const initialUrl = this.browseStorage.getSession('initialUrl');

              this.loginService.loginUser(
                phone,
                token,
                true,
                initialUrl,
                (user) => {
                  this.authService.waitForConfirmation(
                    user.vid,
                    user.phone
                  );
                  this.router.navigate(["confirmation"], { queryParams: otherParams });
                },
                (error) => {
                  this.router.navigate(["login"], { queryParams: otherParams });
                }
              );
            } else {
              this.router.navigate(["login"], { queryParams: otherParams });
            }
          },
          () => this.router.navigate(["login"], { queryParams: otherParams })
        );
    });
  }
}
